import { useEffect } from 'react';
import type { Map as MapTypes, GeoJSONSource } from 'mapbox-gl';

import { zoomToCity } from '../utils';
import { REGIONS_LAYER } from '../constants';

interface useHotelsLayerProps {
  regionsList: GeoJSON.Feature[];
  mapbox?: MapTypes;
}

/**
 * Когда стили карты загружены, наносим список отелей
 */
export const useRegionsLayer = (props: useHotelsLayerProps): void => {
  const { mapbox, regionsList } = props;

  useEffect(() => {
    if (mapbox) {
      const hotelsData: GeoJSON.FeatureCollection<GeoJSON.Geometry> = {
        type: 'FeatureCollection',
        features: regionsList,
      };

      const hotelSource = mapbox.getSource('places_prices') as GeoJSONSource;
      hotelSource.setData(hotelsData);
    }
  }, [regionsList, mapbox]);

  useEffect(() => {
    if (!mapbox) return;

    // при клике на регион, зумим карту, чтобы видеть отели
    mapbox.on('click', REGIONS_LAYER, (e) => zoomToCity(mapbox, e));

    // меняем вид курсора, чтобы показать, что регионы кликабельные
    mapbox.on('mouseenter', REGIONS_LAYER, () => {
      mapbox.getCanvas().style.cursor = 'pointer';
    });
    mapbox.on('mouseleave', REGIONS_LAYER, () => {
      mapbox.getCanvas().style.cursor = '';
    });
  }, [mapbox]);
};
